import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, of, Subject, Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { FormBuilder, Validators } from '@angular/forms';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';
import { AuthService } from '../../../../../core/auth';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { AlarmNotificationListService } from '../../../../../core/alarms/_services/alarm-notification-list.service';
import { PartnerService } from '../../../../../core/auth/_services/partner.service';

@Component({
  selector: 'kt-notification-list-edit',
  templateUrl: './notification-list-edit.component.html',
  styleUrls: []
})
export class NotificationListEditComponent implements OnInit, OnDestroy, AfterViewInit {
  itemObs = new Subject<any[]>();
  editObs = new Subject<number>();
  addObs = new Subject<number>();
  private itemFormOptions = {
    name: ["", Validators.required],
    partner_id: [null]
    // company_id: ["-1", Validators.required],
  };
  itemForm = this.formBuilder.group(this.itemFormOptions);
  stepList: any[] = [
    {
      icon: "flaticon2-architecture-and-city", title: "Definición de la lista de personas", subTitle: "Ingrese el nombre de la lista", form: [
        [
          { name: "name", label: "Nombre", type: "text" },
        ]
      ]
    }, {
      icon: "flaticon-users-1", title: "Configuración de lista", subTitle: "Seleccione quienes serán las personas", form: [
        [
          { name: "partner_id", listTitle: 'Personas asignadas', label: "Personas", type: "multiple", optionList: [], selected: [] },
        ],
      ]
    },
  ];

  private subscriptions: Subscription[] = [];
  data: any = {};
  partnerList: any[] = [];
  userList: any[];
  uid: number = -1;
  company: any = null;

  constructor(
    private alarmNotificationListService: AlarmNotificationListService,
    private partnerService: PartnerService,
    // private companyService: CompanyService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.uid = this.authService.getUID();
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.partnerService.getAll())
      ).subscribe(partnerList => {
        this.partnerList = partnerList;
        this.data.partnerList = partnerList;
        this.stepList[1].form[0][0].optionList = partnerList.map(partner => {
          return {
            value: partner.id,
            text: partner.name
          };
        });
      })
    );
    // this.subscriptions.push(
    //     of(null).pipe(
    //         switchMap(()=>this.companyService.companyLoaded$),
    //         filter((companyLoaded)=>companyLoaded==true)
    //     ).subscribe((companyLoaded)=>{
    //       if(companyLoaded){
    //         this.company = this.companyService.getCurrentCompany();
    //       }
    //         // this.stepList[0].form[1][0].optionList = companyList.map(company=>{return{text:company.name, value:company.id}})
    //         // this.data.companyList = companyList;
    //     })
    // )
  }
  ngAfterViewInit() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onItemLoaded(item) {
    console.dir(item);
    if (item.partner_list && item.partner_list.length > 0)
      this.stepList[1].form[0][0].selected = item.partner_list.map(partner=>parseInt(partner.partner_id));
    console.dir(this.stepList);
      this.cdr.detectChanges();
  }

  getItem(itemId: number) {
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.alarmNotificationListService.getById(itemId))
      ).subscribe(item => {
        this.onItemLoaded(item);
        this.itemObs.next(item);
      })
    )
  }

  addItem(item: any) {
    item.create_uid = this.uid > 0 ? this.uid : 'null';
    item.create_date = "now()";
    // item.is_installation_contact = 'true';
    // item.active = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.alarmNotificationListService.add(item))
      ).subscribe(newId => {
        this.addObs.next(newId);
      })
    )
  }

  editItem(item: any) {
    item.write_uid = this.uid > 0 ? this.uid : 'null';
    item.write_date = "now()";
    // item.is_installation_contact = 'true';
    this.subscriptions.push(
      of(null).pipe(
        switchMap(() => this.alarmNotificationListService.edit(item))
      ).subscribe(status => {
        if (status == "success") this.editObs.next(item.id);
        else this.editObs.next(-1);
      })
    )
  }
}